export const isFullStatic = true
export const staticPath = "/codebuild/output/src1993466134/src/acredo-website/node_modules/.cache/nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"